import {useEffect} from "react";

interface useHotKeyOptions {
    alt?: boolean;
    ctrl?: boolean;
    shift?: boolean;
}

const INPUTS = ["INPUT", "TEXTAREA"];

export const useHotKey = (keyCode: string, action: () => void, options: useHotKeyOptions = {}, deps: any[] = []) => {
    const {alt, ctrl, shift} = Object.assign({alt: false, ctrl: false, shift: false}, options);

    useEffect(() => {
        const listener = ({altKey, ctrlKey, shiftKey, code, target}: KeyboardEvent) => {
            if (target && INPUTS.includes((target as HTMLElement).tagName)) return;
            if (altKey === alt && ctrlKey === ctrl && shiftKey === shift && code === keyCode && typeof action === "function") {
                action();
            }
        };

        document.addEventListener("keyup", listener);

        return () => {
            document.removeEventListener("keyup", listener);
        };
    }, deps);
};
